import moment from 'moment'
import janooService from '@/services/janoo/index'
import bocapioService from '@/services/cakephp/index'
import nodeService from '@/services/nodejs/index'

const bookingStoreCommit = (state, payload) => {
  state.commit(payload.mutation, payload.value)
}

const fetchDialCodes = async (state) => {
  bocapioService.getCountriesDialcode().then((resp) => {
    state.commit(
      'SET_DIAL_CODES_ARRAY',
      Object.values(JSON.parse(resp.countries))
    )
  })
}

const fetchCountries = async (state) => {
  bocapioService.getCountries().then((resp) => {
    state.commit(
      'SET_COUNTRIES_ARRAY',
      Object.values(JSON.parse(resp.countries))
    )
  })
}

const fetchStates = async (state, country) => {
  bocapioService.getUF(country).then((resp) => {
    state.commit('SET_STATES_ARRAY', Object.values(JSON.parse(resp.states)))
  })
}

const fetchCities = async (state, addressState) => {
  bocapioService.getCities(addressState).then((resp) => {
    var citiesJson = JSON.parse(resp.cities)
    state.commit('SET_CITIES_ARRAY', Object.entries(citiesJson))
  })
}

const publicDataBody = (response) => {
  const body = (response && response.data) || response || {}
  return body.place ? body : { place: body }
}

const fetchPlacePublicData = async (state, PLACE_UUID) => {
  state.commit('RESET_PLACE_PUBLIC_DATA')
  if (!PLACE_UUID) return

  const response = await nodeService.getPlacePublicData(PLACE_UUID)
  state.commit('SET_PLACE_PUBLIC_DATA', publicDataBody(response))
}

const saveLocalPayments = async (state, payments) => {
  await nodeService.saveLocalPayments(payments)
}

const fetchTermsConditions = async (state, PLACE_UUID) => {
  const loadTerm = async (uuid) => {
    if (!uuid) {
      uuid = process.env.VUE_APP_UUID_JANOO
      state.commit('RESET_TERMS_CONDITIONS')
    }

    try {
      const response = await nodeService.getPlacePublicData(uuid)
      const body = publicDataBody(response)
      return (body.place && body.place.term) || ''
    } catch (error) {
      return ''
    }
  }

  const term = await loadTerm(PLACE_UUID)
  if (!PLACE_UUID) {
    state.commit('SET_TERMS_CONDITIONS', {
      term: term,
    })
  }

  return term
}

const PLACEHOLDER_CPF = '01234567890'

const customerCpf = (value) => {
  const text = String(value == null ? '' : value).trim()
  if (text.replace(/\D/g, '') === PLACEHOLDER_CPF) return ''
  return text
}

const createLaterExpressBooking = (state, form) => {
  state.commit('RESET_EXPRESSBOOKING_RESPONSE')

  const FORM_COPY = { ...form }
  FORM_COPY.cpf_cnpj = customerCpf(FORM_COPY.cpf_cnpj)

  nodeService
    .createGetnetQRPix(FORM_COPY)
    .then((result) => {
      state.commit('SET_EXPRESSBOOKING_RESPONSE', result.data)
    })
    .catch((err) => {
      console.error('ERROR >>>', err)
    })
}

const createExpressBooking = (state, form) => {
  state.commit('RESET_EXPRESSBOOKING_RESPONSE')
  const auth = state.rootState.auth
  const FORM_COPY = { ...form }
  FORM_COPY.cpf_cnpj = customerCpf(FORM_COPY.cpf_cnpj)
  const payment_labels = {
    credit: 'Crédito',
    debit: 'Débito',
    money: 'Dinheiro',
    pix: 'Pix',
    cheque: 'Cheque',
    transfer: 'Transferência',
    boleto: 'Boleto',
  }

  var description = `${FORM_COPY.atrativo.product_name} - `
  let order_total_value = 0
  let order_total_discount = 0

  let agent = {
    active: false,
    name: '',
    uuid: '',
    place: '',
  }

  if (auth.user.isAgent) {
    agent.active = true
    agent.name = auth.user.name
    agent.uuid = auth.user.uuid
    agent.place = auth.user.placeName
  }

  const tickets = Object.values(FORM_COPY.tickets)
    .map(function (value, index) {
      if (Number(value.quantity) > 0) {
        description +=
          value.label + ': (' + value.quantity + ' x R$' + value.price + ')'
        order_total_value +=
          Number(value.quantity) * Number(value.price.replace(',', '.'))
        order_total_discount += 0

        return {
          id: value.id,
          title: value.label + ' - ' + FORM_COPY.atrativo.product_name,
          label: value.label,
          booking_name: value.booking_name,
          booking_slug: value.booking_slug,
          quantity: Number(value.quantity),
          unit_price: Number(value.price.replace(',', '.')),
          unit_discount: Number(0),
          picture_url: FORM_COPY.atrativo.images[0],
        }
      }
    })
    .filter((t) => t != null)

  const costumer = {
    phone: { number: FORM_COPY.phone, area_code: FORM_COPY.phoneFlag },
    name: FORM_COPY.name,
    cpf: FORM_COPY.cpf_cnpj,
    email: FORM_COPY.email,
  }

  const vendor = {
    //uuid: FORM_COPY.atrativo.place_uuid, //TODO: id do place
    store_name: FORM_COPY.atrativo.vendor_name || 'gestor',
    phone: FORM_COPY.atrativo.vendor_number,
    email: FORM_COPY.atrativo.vendor_email,
    address: {
      street_1: '',
      street_2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
    },
  }

  const order = {
    ID: '',
    total_value: String(Number(order_total_value).toFixed(2)),
    total_discount:
      order_total_discount > 0
        ? String(Number(order_total_discount).toFixed(2))
        : '0',
    final_value: String(
      Number(order_total_value - order_total_discount).toFixed(2)
    ),
  }

  const product = {
    id: FORM_COPY.atrativo.id,
    uuid: FORM_COPY.atrativo.uuid,
    name: FORM_COPY.atrativo.product_name,
    address: `${FORM_COPY.address.city}-${FORM_COPY.address.state}`,
    place: FORM_COPY.atrativo.vendor_name || 'gestor',
    product_notification_number: FORM_COPY.atrativo.notification_number,
    product_nps: FORM_COPY.atrativo.nps_link,
    groups: FORM_COPY.atrativo.nps_group,
    place_uuid: FORM_COPY.atrativo.place_uuid,
  }

  let term = {
    hash: FORM_COPY.hash,
    confirm: FORM_COPY.confirm_term,
    datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
  }

  let checkins = []

  let agents = []

  let defaultPaymentData = {
    payment_value: '0',
    payment_method: 'cod',
    payment_status: 'PENDING',
    payment_description: 'Pendente',
    payment_date: new Date().toISOString(),
    operator_uuid: 'null',
    data_origin: {
      payment_type: 'cod',
      order_id: 'null',
      payment_id: 'null',
      amount: '0',
      status: 'PENDING',
      transaction_id: 'null',
      transaction_timestamp: new Date().toISOString(),
      payer_name: costumer.name,
      payer_cnpj: '',
      payer_cpf: costumer.cpf,
      receiver_psp_name: FORM_COPY.atrativo.vendor_name || 'gestor',
      receiver_psp_code: '0',
      receiver_name: FORM_COPY.atrativo.product_place_name,
      receiver_cnpj: '',
      receiver_cpf: '',
    },
  }

  let payments = [defaultPaymentData]

  if (FORM_COPY.payment_method == 'set_cod') {
    let settedPayments = []

    costumer.cpf = costumer.cpf || ''
    ;(FORM_COPY.localPayments || []).map((payment) => {
      let cod = { ...defaultPaymentData }

      cod.payment_value = Number(payment.amount)
      cod.payment_method = payment.method
      cod.payment_status = 'APPROVED'
      const methodName = String(payment.method || '').split('_').slice(1).join('_')
      cod.payment_description = `Pagamento local em ${
        payment.label || payment_labels[methodName] || methodName
      }`
      cod.operator_uuid = auth.user ? auth.user.uuid : ''
      cod.data_origin = {
        payment_type: payment.method,
        order_id: 'null',
        payment_id: 'null',
        amount: payment.amount,
        status: 'APPROVED',
        transaction_id: 'null',
        transaction_timestamp: new Date().toISOString(),
        payer_name: costumer.name,
        payer_cnpj: '',
        payer_cpf: costumer.cpf,
        receiver_psp_name: auth.user.placeName,
        receiver_psp_code: auth.user ? auth.user.uuid : '',
        receiver_name: auth.user ? auth.user.name : '',
        receiver_cnpj: '',
        receiver_cpf: '',
      }
      settedPayments.push(cod)
    })

    delete FORM_COPY.localPayments
    payments = settedPayments.filter(
      (payment) => Number(payment.payment_value) > 0
    )
  }

  const defaultSaleObject = {
    //id: FORM_COPY.atrativo_id,                              // ID do atrativo
    hash: FORM_COPY.hash, // Hash da reserva
    created_date: new Date().toISOString(), // Data da reserva
    channel: 'RESERVAEXPRESSA',
    auto_checkin: FORM_COPY.auto_checkin, // Auto check-in
    booking_code: '', // Data da reserva
    booking_date: FORM_COPY.date + ' ' + FORM_COPY.time, // Data da reserva
    description: description, // Descrição dos items comprados (Reserva Expressa)
    booking_slug: FORM_COPY.booking_slug, // Apelido de ingresso comprado
    booking_name: FORM_COPY.booking_name, // Nome de ingresso comprado
    vendor: vendor,
    lastStart: [], // Armazena as datas antes de mudança de datas
    agents: agents, // lista de agents da reserva
    hasAgent: agent, // Condutor encarregado pela reserva
    checkins: checkins, // lista de checkins da reserva
    costumer: costumer, // Dados do comprador
    items: tickets, // Ingressos
    order: order, // Dados do pedido (preço total e descontos)
    product: product, // Dados do atrativo
    payments: payments,
    term: term, // Aceite de termos e condicoes
    payLater: FORM_COPY.payLater, // Pagar depois
    cod_booking: FORM_COPY.cod_booking,
    free_booking: FORM_COPY.free_booking, // Reserva Cortesia
  }

  switch (FORM_COPY.gateway) {
    case 'MPAGO':
      nodeService
        .postCreateExpressBookingMercadoPago(defaultSaleObject)
        .then((result) => {
          const data = result.data
          var callback_URL = data.preference.init_point

          if (process.env.NODE_ENV !== 'production') {
            callback_URL = data.preference.sandbox_init_point
          }

          state.commit('SET_MP_CALLBACK_URL_MP', callback_URL)
        })
        .catch((err) => {
          console.error('ERROR >>>', err)
        })
      break

    case 'EXPRESSBOOKING':
      if (FORM_COPY.payment_method == 'set_cod') {
        defaultSaleObject.payLater = true
        defaultSaleObject.cod_booking = true
        defaultSaleObject.booking_code = ''
        nodeService
          .createLocalPayment(defaultSaleObject)
          .then((result) => {
            state.commit('SET_EXPRESSBOOKING_RESPONSE', result.data)
          })
          .catch((err) => {
            const data = err && err.data
            const message =
              (data && (data.message || data.error)) ||
              'Não foi possível registrar o pagamento no local.'
            state.commit('SET_EXPRESSBOOKING_RESPONSE', {
              error: typeof message === 'string' ? message : 'Não foi possível registrar o pagamento no local.',
            })
          })
        break
      }
      nodeService
        .createGetnetQRPix(defaultSaleObject)
        .then((result) => {
          state.commit('SET_EXPRESSBOOKING_RESPONSE', result.data)
        })
        .catch((err) => {
          console.error('ERROR >>>', err)
        })
      break

    default:
      break
  }
}

export default {
  bookingStoreCommit,
  // fetchProductsList,
  fetchPlacePublicData,
  fetchTermsConditions,
  createExpressBooking,
  createLaterExpressBooking,
  fetchDialCodes,
  fetchCountries,
  fetchStates,
  fetchCities,
  saveLocalPayments,
}
